import Animation from '@eversports/klimt-animations/Animation'
import Box from '@eversports/klimt-primitives/legacy/Box'

import usePrefersReducedMotion from '../../../../hooks/use-prefers-reduced-motion'

import LineMotion from './assets/line-motion.lottie'

// Figma "Vector 8": a decorative line that draws itself in once, threading behind the voucher
// banner card - poking out above its top-right corner and bleeding past its right and bottom edges.
const BOUNDING_BOX_WIDTH = 602
const BOUNDING_BOX_HEIGHT = 375

export function VoucherLineAnimation() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <Box
      sx={{
        position: 'absolute',
        top: { xs: '15%', sm: '0' },
        right: { xs: '-10%', sm: '0' },
        zIndex: 0,
        width: BOUNDING_BOX_WIDTH,
        height: BOUNDING_BOX_HEIGHT,
        pointerEvents: 'none',
      }}
    >
      <Animation
        src={LineMotion}
        style={{ width: '100%', height: '100%' }}
        loop={false}
        autoplay={!prefersReducedMotion}
      />
    </Box>
  )
}
